import { MaintenanceWindowsDeleteDialogView } from '../view/MaintenanceWindowsDeleteDialogView';
import { templateMaintenanceWindowsDeleteDialog } from '../view/template';
import { MaintenanceWindowsDeleteDialogRepository } from '../repository/MaintenanceWindowsDeleteDialogRepository';
import { BaseWebComponentController, WebComponentEvent } from '../../../framework/BaseWebComponentController';
import { MaintenanceWindowsDeleteDialogWebComponent } from '..';
import { PolicyImpactData } from '../types';

export class MaintenanceWindowsDeleteDialogController extends BaseWebComponentController {
  public component: MaintenanceWindowsDeleteDialogWebComponent;
  public dataRepository: MaintenanceWindowsDeleteDialogRepository;
  public view: MaintenanceWindowsDeleteDialogView;
  public viewConstructor: typeof MaintenanceWindowsDeleteDialogView;
  public dataRepositoryConstructor: typeof MaintenanceWindowsDeleteDialogRepository;

  constructor(component: MaintenanceWindowsDeleteDialogWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: MaintenanceWindowsDeleteDialogView,
      viewTemplate: templateMaintenanceWindowsDeleteDialog,
      dataRepositoryConstructor: MaintenanceWindowsDeleteDialogRepository,
    });
  }

  async getDataForView(): Promise<PolicyImpactData> {
    return this.dataRepository.getDataForView(this.component.companyId, this.component.maintenanceWindowIds);
  }
}
